<template>
	<div style="text-align: center;">
		<div style="border-bottom: 1px solid #f5f5f5;" >
			<br /><br /><br /><br />

			<span style="font-size: 0.8rem;">支付成功</span>
			<br><br>
			<span style="font-size: 1.8rem;">-</span>
			<br><br>
			
		</div>
		<span @click="pageTo('/order/list')">查看订单</span>
		<span @click="pageTo('/')">去首页</span> 
		
		<!-- 组件使用 -->
		<!-- <foot /> -->
		<!-- <syalert ref="syalert_id" /> -->
		
	</div>
</template>
<style>
	.pay-list
	{
		margin: 0.5rem auto;
		width:80%;
		text-align: left;
	}
	.pay-list span
	{
		display: inline-block;
	}
	.pay-list input
	{
		height: 2.5rem;
	}
	.icon-box
	{
		width: 2.5rem;
		height: 2.5rem;
		margin-right: 1.0rem;
		border-radius: 2.5rem;
		border: 1px solid #f5f5f5;
		line-height: 2.5rem;
		text-align: center;
	}
	.icon-weixin
	{
		color: #09BB07;
	}
	.icon-zhifubao
	{
		color: #1890FF;
	}
	
	.pay-buttom
	{
		display: block; 
		width: 14rem; 
		height: 2rem;
		margin: 0.5rem auto; 
		
		line-height: 2rem;
		
		border-radius: 2rem;
		
		font-size: 0.8rem;
		
		color: white;
		background-color: #FF5810;
	}


</style>
<script>
	// 组件引入
	// import sy from "@/sy";
	// import syalert from '@/components/syalert.vue';
	// import foot from '@/components/foot.vue';

	export default {
		name: 'paynotify',
		components: {
			// foot,
			// syalert,
		},
		data() {
			return {
			}
		},
		methods: { 
			pageTo: function(page) {
				if (page !== undefined) {
					this.$router.push(page);
				} else {
					this.$router.go(-1);
				}
			},
			check: function()
			{ 
			}, 
		},
		created()
		{ 
			this.check();
		},
	}
</script>